import React from 'react';
import { Box, Container, Typography, Paper, Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';

export const UnityDocsPage: React.FC = () => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 50%, #16213e 100%)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Paper
          elevation={3}
          sx={{
            backgroundColor: 'rgba(26, 26, 26, 0.9)',
            border: '1px solid #c0c0c0',
            borderRadius: 2,
            p: 4,
          }}
        >
          <Typography
            variant="h3"
            gutterBottom
            sx={{
              color: '#ffffff',
              fontWeight: 700,
              mb: 3,
              textAlign: 'center',
              background: 'linear-gradient(135deg, #9b59b6 0%, #c74375 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            Unity Integration Tutorial
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: '#c0c0c0',
              mb: 4,
              textAlign: 'center',
              fontSize: '1.1rem',
            }}
          >
            Learn how to integrate EmotionCap with your Unity projects
          </Typography>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mb: 4,
            }}
          >
            <Button
              variant="contained"
              startIcon={<DownloadIcon />}
              href="https://github.com/Nina-Software/EmotionCap-Unity3d/releases/download/1.0.0/com.ninasoftware.emotioncap.1.0.0.unitypackage"
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                background: 'linear-gradient(135deg, #9b59b6 0%, #c74375 100%)',
                color: '#ffffff',
                fontWeight: 600,
                fontSize: '1rem',
                px: 4,
                py: 1.5,
                textTransform: 'none',
                borderRadius: 2,
                boxShadow: '0 4px 15px rgba(155, 89, 182, 0.4)',
                transition: 'all 0.3s ease',
                '&:hover': {
                  background: 'linear-gradient(135deg, #8e44ad 0%, #b03a62 100%)',
                  boxShadow: '0 6px 20px rgba(155, 89, 182, 0.6)',
                  transform: 'translateY(-2px)',
                },
              }}
            >
              Download Unity Integration Pack
            </Button>
          </Box>

          <Box
            sx={{
              position: 'relative',
              paddingBottom: '56.25%', // 16:9 aspect ratio
              height: 0,
              overflow: 'hidden',
              borderRadius: 2,
              border: '2px solid #c0c0c0',
              backgroundColor: '#000',
            }}
          >
            <iframe
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: 'none',
              }}
              src="https://www.youtube.com/embed/uWFkuidd7wY"
              title="Unity Integration Tutorial"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </Box>

          <Box sx={{ mt: 4 }}>
            <Typography
              variant="h5"
              sx={{
                color: '#ffffff',
                fontWeight: 600,
                mb: 2,
              }}
            >
              What you'll learn:
            </Typography>
            <Typography
              component="ul"
              sx={{
                color: '#c0c0c0',
                fontSize: '1rem',
                lineHeight: 2,
                '& li': {
                  mb: 1,
                },
              }}
            >
              <li>How to set up EmotionCap in your Unity project</li>
              <li>Connecting real-time facial motion capture to Unity characters</li>
              <li>Configuring blend shapes and animation rigging</li>
              <li>Best practices for smooth integration</li>
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};
